<template>
  <!-- 舆情-新增-详细描述 -->
  <div class="add_negative">
    <div class="steps">
      <div class="step actived">
        <span class="index">1</span>
        <span class="cont">舆情概况</span>
      </div>
      <div class="line"></div>
      <div class="step active">
        <span class="index">2</span>
        <span class="cont">详细描述</span>
      </div>
      <div class="line"></div>
      <div class="step">
        <span class="index">3</span>
        <span class="cont">所涉州市</span>
      </div>
    </div>
    <div class="content contentdesc">
      <div class="accident">
        <div class="tip">信息来源</div>
        <div class="input">
          <input type="text" maxlength="100"  v-model="infoSource" placeholder="请输入" />
        </div>
      </div>
      <div class="accident">
        <div class="tip">发布时间</div>
        <div class="drop_down" @click="showTime">
          <span v-if="!selectTime.value">请选择</span>
          <span v-if="selectTime.value" class="selected">{{selectTime.name}}</span>
          <img src="@/assets/appraise/arrow_right.png" alt />
        </div>
      </div>
      <div class="accident">
        <div class="tip">网络走势</div>
        <div class="input">
          <input type="text" maxlength="100"  v-model="netTend" placeholder="请输入" />
        </div>
      </div>
      <div class="reason main_cont">
        <div class="reason_tit">主要内容</div>
        <div class="about_content">
            <textarea class="content" style="resize: none;" placeholder="请输⼊主要内容" maxlength="500" v-model="opinionDesc"></textarea>
        </div>
      </div>
      <div class="reason">
        <div class="reason_tit">舆情链接</div>
        <div class="about_content">
            <textarea class="content" style="resize: none;"  placeholder="请输入" maxlength="100" v-model="infoUrl"></textarea>
        </div>
      </div>
      <div class="upload_file">
        <div class="upload_tit">相关材料</div>
        <div class="file_item" v-for="item in fileResVOS" :key="item.id">
          <div class="file_msg">
            <img v-if="item.fileType ==='exl'" src="@/assets/appraise/ic_exl.png" alt />
            <img v-if="item.fileType ==='doc'" src="@/assets/appraise/ic_doc.png" alt />
            <img v-if="item.fileType ==='pdf'" src="@/assets/appraise/ic_pdf.png" alt />
            <!-- <img v-else /> -->
            <p class="file_name">
              <span>{{item.fileName}}.{{ item.fileType}}</span>
            </p>
          </div>
          <div class="delImg" @click="del(item)">
            <img src="@/assets/appraise/delete.png" alt />
          </div>
          <!-- <div class="file_size">{{item.fileSize}}</div> -->
        </div>
        <addBtn v-if="fileResVOS && fileResVOS.length<10" :isShowSpan="true" :isGoAndroidandIOS="true" :needEmit="true" @fields="getFiles"></addBtn>
      </div>
      <div class="kdiv"></div>
    </div>
    <div class="bot_btns">
      <van-button @click="prevStep" class="prev_btn" type="primary">上一步</van-button>
      <van-button @click="nextStep" class="next_btn" type="primary">下一步</van-button>
    </div>
    <titleDialog
      v-if="showDialog"
      :title="dialogTitle"
      :cancelTxt="cancelBtn"
      :confirmTxt="confirmBtn"
      @confirm="confirm"
      @cancel="cancel"
    ></titleDialog>
    <tipDialog :isShow="showTips" :content="requireCont" @closeModal="showTips=false"></tipDialog>
    <timePick @getTimeValue="getTimeValue" ref="timePick"></timePick>
  </div>
</template>

<script>
import titleDialog from "@/pages/appraise/components/titleDialog.vue";
import addBtn from "../appraiseNew/components/addBtn.vue";
import timePick from "../../../components/base/timePick.vue";
import tipDialog from "./components/tipDialog";
export default {
  components: {
    titleDialog,
    addBtn,
    timePick,
    tipDialog
  },
  data() {
    return {
      showTips: false,
      showDialog: false,
      requireCont: "",
      dialogTitle: "",
      cancelBtn: "",
      confirmBtn: "",
      requireCont: "",
      quarter: this.$route.query.quarter,
      year: this.$route.query.year,
      area: this.$route.query.area,
      opinionDesc: "", // 主要内容
      delItem: {},
      infoSource: "", // 信息来源
      issuanceTime: "", // 发布时间
      netTend: "", // 网络走势
      infoUrl: "", // 舆情链接
      selectTime: {},
      fileResVOS: [] // 相关材料
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      let negativeDesc = this.$store.state.appraise.negativeDesc;
      console.log(negativeDesc, '00000')
      if (negativeDesc.opinionDesc) {
        (this.opinionDesc = negativeDesc.opinionDesc),
          (this.infoSource = negativeDesc.infoSource),
          (this.selectTime = {
            value: negativeDesc.issuanceTime,
            name: negativeDesc.issuanceTime.split('-')[0] + '年' +negativeDesc.issuanceTime.split('-')[1] + "月" +negativeDesc.issuanceTime.split('-')[2]+'日'
          }),
          (this.netTend = negativeDesc.netTend),
          (this.infoUrl = negativeDesc.infoUrl),
          (this.fileResVOS = negativeDesc.fileResVOS);
      }
    },
    // 上一步
    prevStep() {
      // this.$router.back(-1);
      this.$router.replace(
        `/appraise/addNegative?id=${this.$route.query.id}&year=${this.year}&quarter=${this.quarter}&area=${this.area}`
      );
    },
    // 下一步
    nextStep() {
      if (this.infoSource == "") {
        this.showTips = true;
        this.requireCont = "请填写“信息来源”";
        return;
      } else if (!this.selectTime.value) {
        this.showTips = true;
        this.requireCont = "请选择“发布时间”";
        return;
      } else if (this.netTend == "") {
        this.showTips = true;
        this.requireCont = "请填写“网络走势”";
        return;
      } else if (this.opinionDesc == "") {
        this.showTips = true;
        this.requireCont = "请填写“主要内容”";
        return;
      } else if (this.infoUrl == "") {
        this.showTips = true;
        this.requireCont = "请填写“舆情链接”";
        return;
      } else if (this.fileResVOS.length == 0) {
        this.showTips = true;
        this.requireCont = "请上传相关附件";
        return;
      }
      this.saveDesc();
    },
    // 点击下一步
    saveDesc() {
      let negativeDesc = this.$store.state.appraise.negativeDesc;
      let data = {
        opinionDesc: this.opinionDesc,
        infoSource: this.infoSource,
        issuanceTime: this.selectTime.value,
        netTend: this.netTend,
        infoUrl: this.infoUrl,
        fileResVOS: this.fileResVOS
      };
      this.$store.commit("appraise/setNegativeDesc", data);
      this.$router.replace(
        `/appraise/addNegativeCitis?id=${this.$route.query.id}&year=${this.year}&quarter=${this.quarter}&area=${this.area}`
      );
    },
    showTime() {
      this.$refs.timePick.showPicker();
    },
    getTimeValue(val) {
      this.selectTime = {
        name:
          val.split("-")[0] +
          "年" +
          val.split("-")[1] +
          "月" +
          val.split("-")[2] +
          "日",
        value: val
      };
    },
    // 删除附件
    del(item) {
      this.dialogTitle = "是否确定删除附件";
      this.cancelBtn = "取消";
      this.confirmBtn = "删除";
      this.isSave = "1";
      this.delItem = item;
      this.showDialog = true;
    },
    // 上传附件回调
    getFiles(file) {
      this.fileResVOS.push(file[0]);
    },
    // 弹窗确认回调
    confirm() {
      let index = this.fileResVOS.indexOf(this.delItem);
      this.fileResVOS.splice(index, 1);
      this.showDialog = false;
    },
    // 弹窗失败回调
    cancel() {
      this.showDialog = false;
    }
  }
};
</script>

<style scoped lang="less">
.add_negative{
  width: 100%;
  height: 100%;
  position: relative;
  // overflow-y: auto;
}
.steps {
  padding: 25px 12px;
  background-color: #fbfbfb;
  height: 66px;
  & > div {
    display: inline-block;
  }
  .step.active {
    .cont {
      color: #36b374;
    }
    .index {
      background-color: #36b374;
    }
  }
  .step.actived {
    .cont {
      color: #36b374;
      opacity: 0.5;
    }
    .index {
      background-color: #36b374;
      opacity: 0.5;
    }
  }
  .index {
    display: inline-block;
    margin-right: 4px;
    width: 16px;
    height: 16px;
    line-height: 16px;
    font-size: 10px;
    color: #fff;
    text-align: center;
    // background-color: #36B374;
    background-color: #ccc;
    border-radius: 50%;
    vertical-align: text-bottom;
  }
  .line {
    display: inline-block;
    margin: 0 11px;
    width: 38px;
    height: 1px;
    background-color: #ccc;
    vertical-align: middle;
  }
  .cont {
    font-size: 14px;
    color: #ccc;
  }
}
.content {
  // padding: 0 12px 86px;
  // height: calc(100% - 66px);
}
.contentdesc{
  overflow-y: auto;
  padding: 0 12px 86px;

}
.accident {
  display: flex;
  justify-content: space-between;
  padding: 16px 0;
  height: 46px;
  border-bottom: 1px solid #ededed;
  .tip {
    color: #666;
    font-size: 14px;
  }
  .input input {
    width: 280px;
    font-size: 14px;
    text-align: right;
  }
  .input input::-webkit-input-placeholder {
    font-size: 14px;
    color: #ccc;
    text-align: right;
  }
  .drop_down {
    span {
      margin-right: 4px;
      color: #ccc;
      font-size: 14px;
    }
    img {
      display: inline-block;
      width: 12px;
      height: 12px;
      vertical-align: text-top;
    }
    span.selected {
      color: #333;
      font-size: 14px;
    }
  }
}
.reason {
  .reason_tit {
    padding: 16px 0 12px;
    color: #666;
    font-size: 14px;
  }
  .content {
    .van-field {
      padding: 16px 12px 0;
      height: 120px;
      overflow: auto;
      background-color: #f5f5f5;
    }
    /deep/ .van-field__body {
      height: 100px;
      textarea {
        max-height: 100px;
      }
    }
    /deep/ .van-field__word-limit {
      font-size: 14px;
      color: #333;
      span {
        color: #999;
      }
    }
  }
}
.main_cont {
  padding-bottom: 16px;
  border-bottom: 1px solid #ededed;
}
.bot_btns {
  position: fixed;
  // position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px 12px;
  height: 60px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px -2px 8px 0px rgba(0, 0, 0, 0.03);
  .van-button {
    width: 165px;
    height: 40px;
    background-color: #36b374;
  }
  .prev_btn {
    margin-left: 3px;
    margin-right: 15px;
    color: #36b374;
    background-color: #fff;
  }
}
@supports (bottom:  env(safe-area-inset-bottom)) {
  .add_negative{
    padding-bottom: calc( env(safe-area-inset-bottom));
  }
  .bot_btns{
    bottom:  env(safe-area-inset-bottom);
    bottom: constant(safe-area-inset-bottom);
  }
  .bot_btns::after{
    content: '';
    height:  env(safe-area-inset-bottom);
    height: constant(safe-area-inset-bottom);
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background-color: #fff;
  }
}
.upload_file {
  // margin-bottom: 17px;
  padding: 0 0 16px;
  background-color: #fff;
  .upload_tit {
    padding: 16px 0;
    font-size: 14px;
    color: #666;
  }
}
.file_item {
  display: flex;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 15px;
  .file_msg {
    flex: 1;
    display: flex;
    align-items: center;
  }
  .file_msg img {
    margin-right: 12px;
    width: 34px;
    height: 38px;
  }
  .file_msg p {
    font-size: 14px;
    color: #333;
    span {
      line-height: 20px;
      word-break: break-word;
    }
  }
  .file_size {
    font-size: 12px;
    color: #999;
  }
  .delImg {
    box-sizing: border-box;
    line-height: 38px;
    margin-left: 5px;
    margin-right: 10px;
  }
  .delImg img {
    width: 15px;
    height: 16px;
  }
}
.about_content{
     width:100%;
     position: relative;
     .content{
       width:100%;
       height:120px;
       font-size:14px;
       color:#323233;
       background-color: #f5f5f5;
       border:0;
       outline: none;
       border-radius: 3px;
       padding:16px;
       box-sizing: border-box;
       line-height: 1.3em;
    }
  }
  .kdiv{
    height: 42px;
  }
</style>